
// Connection Info for various APIs
// export const API_URL = "http://143.198.45.167";   // The URL for our API
// export const API_URL = "http://localhost:8000";
//export const API_URL = "https://www.pizzago.menu";
export const API_URL = "https://api.click2order.ca";
export const GOOGLE_API_KEY = "AIzaSyBYsSXvaFjkGkz7l5Y859CqavaTV4ycx-Q";
export const ONLINE_URL = "https://order.click2order.ca/";
export const VERSION = "1.2"; // Internal API version
export const SOURCE = "online";

// Whitelabel and Dispatch IDs
export const WLID = 0;                          // Whitelabel Location ID
export const DID = 0;                            // Dispatch ID (6 for CBEats, 5 for demo)
export const ADID = 9;                            // App Directory ID
export const COMPANY_NAME = 'CB Eats';

// Default Latitide/Longitude
export const DEFAULT_LATITUDE = 46.14315050;
export const DEFAULT_LONGITUDE = -60.19640920;

// Style Constants
export const COLOR_PRIM = "#FE5B5D";
export const COLOR_SEC = "#ff5c5c";
export const COLOR_BORDER = "#f1f1f1";
export const COLOR_POSITIVE = "#37b644";
export const COLOR_FONT_PRIM = "#333333";
export const COLOR_FONT_SEC = "#c0c0c0";
export const FONT_PRIM = "Ubuntu";
export const FONT_PRIM_ITALIC = "Ubuntu-Italic";
export const FONT_PRIM_BOLD = "Ubuntu-Bold";
export const FONT_PRIM_LIGHT = "Ubuntu-Light";
export const FONT_SEC = "Raleway";
export const FONT_SEC_BOLD = "Raleway-Bold";
export const FONT_SEC_LIGHT = "Raleway-Light";

// Font Family for Android stuff
export const FONT_ANDROID_NORMAL = "Roboto-Black";
export const FONT_ANDROID_LIGHT = "Roboto-Light";
export const FONT_ANDROID_MEDIUM = "Roboto-Medium";
export const FONT_ANDROID_BOLD = "Roboto-Bold";

//Poppins fonts to match webflow designs
export const FONT_POPPINS_BOLD = "Poppins-Bold";
export const FONT_POPPINS_EXTRA_BOLD = "Poppins-ExtraBold";
export const FONT_POPPINS_LIGHT = "Poppins-Light";
export const FONT_POPPINS_REGULAR = "Poppins-Regular";

export const MENU_BG = '#d80000';
export const COLOR_MENU_MAIN = '#fefefe';
export const COLOR_MENU_CART = '#fefefe';

// Tagged Order Colors
export const COLOR_ORDER_TAGGED = '#3a81b7';
export const COLOR_ORDER_PRESSED = '#fdff70';
export const COLOR_ORDER = '#fe5b5d';

// Regex Conditions
export const PHONE_REGEX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
export const EMAIL_REGEX = /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}\s*$/;

// OneSignal
export const ONESIGNAL_APP_ID = "60ec7656-f90c-44f0-a001-c71756b8d73d";
